export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "exported_batch": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del lote"])},
            "packing_house_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso de empaque"])},
            "packing_house": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Planta de empaque"])},
            "batch_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peso total"])},
            "crop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultivo"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
            "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organización"])},
            "crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])},
            "crop_field_sector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sector"])},
            "agro_exporter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agro exportadora"])},
            "agro_exporter_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proceso"])},
            "packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaques exportados"])}
          }
        }
      },
      "en": {
        "model": {
          "exported_batch": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Batch data"])},
            "packing_house_process": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packing house process"])},
            "packing_house": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Packing house"])},
            "batch_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total weight"])},
            "crop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer"])},
            "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organization"])},
            "crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Field"])},
            "crop_field_sector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sector"])}
          }
        }
      }
    }
  })
}